import { Component, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogClose,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { SnackbarService } from '@services/snackbar.service';
import { DiscrepancyService } from '@services/api/discrepancy/discrepancy.service';
import { FlatButtonComponent } from '@shared/button/flat-button/flat-button.component';
import { LoaderComponent } from '@shared/loader/loader.component';
import { DiscrepancyIdNo } from '@models/discrepancy/item';
import { refreshActionRelatedData } from 'app/store/actions/discrepancy.actions';
import DATA_QA from '@automation/data-qa.json';

@Component({
    templateUrl: 'discard-discrepancy-dialog.component.html',
    imports: [FlatButtonComponent, MatDialogClose, LoaderComponent],
})
export class DiscardDiscrepancyDialogComponent {
    loading: boolean = false;
    error: boolean = false;
    readonly dataQa = DATA_QA;

    private readonly store = inject(Store);
    private readonly discrepancyService = inject(DiscrepancyService);
    private readonly snackbarService = inject(SnackbarService);
    private readonly dialogRef = inject(
        MatDialogRef<DiscardDiscrepancyDialogComponent>,
    );
    readonly data: DiscrepancyIdNo = inject(MAT_DIALOG_DATA);

    discard() {
        this.loading = true;
        this.error = false;

        this.discrepancyService.discardDiscrepancy(this.data.id).subscribe({
            next: (success) => {
                this.loading = false;
                if (success) {
                    this.snackbarService.success({
                        variant: 'success',
                        header: `Discrepancy ${this.data.discrepancyNo} Discarded`,
                    });
                    this.dialogRef.close();
                    this.store.dispatch(refreshActionRelatedData());
                } else {
                    this.error = true;
                }
            },
        });
    }
}
